<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
                Faturas
            </div>

            <b-button @click="canShow = !canShow" variant="default" size="sm">
                <i class="fas fa-minus" v-if="canShow"></i>
                <i class="fas fa-plus" v-else></i>
            </b-button>
        </div>
        <div class="card-body" v-show="canShow">
            <b-overlay :show="loading" rounded="sm">
                <b-table table-class="bg-white" responsive bordered :items="receipts" :fields="fields">
                    <template v-slot:cell(amount)="row">
                        <span v-if="row.item.amount">
                            {{ formatPrice(row.item.amount) }}
                        </span>
                        <span v-else>
                            {{ formatPrice(0) }}
                        </span>
                    </template>

                    <template v-slot:cell(due_at)="row">
                        <span v-if="row.item.due_at">
                            {{ row.item.due_at | moment('DD/MM/YYYY HH:mm') }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(created_at)="row">
                        {{ row.item.created_at | moment('DD/MM/YYYY HH:mm') }}
                    </template>

                    <template v-slot:cell(status)="row">
                        <span v-if="row.item.status === 'pending'" class="text-info">
                            Pendente
                        </span>
                        <span v-if="row.item.status === 'paid'" class="text-success">
                            Paga
                        </span>
                        <span v-if="row.item.status === 'canceled'" class="text-danger">
                            Cancelada
                        </span>
                        <span v-if="row.item.status === 'scheduled'" class="text-info">
                            Agendada
                        </span>
                        <span v-if="row.item.status === 'failed'" class="text-danger">
                            Falhou
                        </span>
                    </template>

                    <template v-slot:cell(metadata)="row">
                        <div v-if="row.item.metadata && row.item.metadata.nfeio_issuance_error_message === null">
                            <a class="btn btn-primary btn-sm" target="_blank" :href="row.item.metadata.nfeio_pdf_url">
                                Baixar
                            </a>
                        </div>
                        <p v-else class="">
                            ---
                        </p>
                    </template>
                </b-table>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import formatPrice from '../formatPrice'

export default {
    mixins: [formatPrice],
    data() {
        return {
            loading: false,
            receipts: [],
            canShow: false,
            fields: [
                {key: 'code', label: 'Código'},
                {key: 'name', label: 'Nome'},
                {key: 'amount', label: 'Valor'},
                {key: 'due_at', label: 'Vencimento'},
                {key: 'created_at', label: 'Criado em'},
                {key: 'metadata', label: 'Nota Fiscal'},
                {key: 'status', label: 'Status'},
            ],
        }
    },
    created() {
        // Load Receipts
        this.loadReceipts();

        this.$root.$on('reloadReceipts', () => {
            this.loadReceipts();
        })
    },
    destroyed() {
        this.$root.$off('reloadReceipts');
    },
    methods: {
        async loadReceipts() {
            this.loading = true;

            await axios.get('/teacher/pagarme/receipts')
                .then((response) => {
                    this.receipts = response.data.data.receipts || [];
                    this.$emit('receiptsEmit', this.receipts);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
